import './product-support-overview.scss';

import { smoothScrollTo } from '../../js/helper';

class ProductSupportOverview {
    constructor (element) {
        this.$productSupportOverview = element;
        this.$productOverviewBackButton = document.querySelector('.product-support-overview-back');
        this.$productSupportTopText = document.querySelector('.products-support-text');
        this.$productSupportUrl = this.$productSupportOverview.getAttribute('data-product-support-url');
        this.$productSupportFormResults = document.querySelector('.product-support-form-results');
        this.$productSupportResultsContainer = document.querySelector('.product-support-form-results-container');
        this.$productSupportResultsPreview = document.querySelector('.product-support-form-results-prev');
        this.$productSupportFilter = document.querySelector('[data-productsupport-filter="root"]');
        this.$header = document.querySelector('[data-header="root"]');
        this.documentTitle = document.title;
    }

    initialize () {
        if (this.$productSupportOverview) {
            this.checkUrl(false);
            this.setEvents();
        }
    }

    checkUrl (withScroll) {
        const locationHash = window.location.hash;
        const $productSupportTabs = document.querySelector('.product-support-tabs');

        if (locationHash) {
            this.hideResults();
            this.$productOverviewBackButton.classList.remove('is--hidden');
            const tabToOpen = locationHash.replace('#', '');
            const $activeTabItem = $productSupportTabs.querySelector('[data-tab-button="' + tabToOpen + '"]');
            const historyStateObject = {
                category: 'product-support',
                pageType: 'overview',
                tabSelected: tabToOpen
            };

            if (withScroll) {
                let positionTop = (this.$productOverviewBackButton.getBoundingClientRect().top + window.scrollY) - 2 * this.$productOverviewBackButton.offsetHeight;
                if (this.$header) {
                    positionTop = positionTop - this.$header.offsetHeight;
                }

                const windowWidth = window.innerWidth;
                if (windowWidth < 768) {
                    const $productSupportText = document.querySelector('.products-support-text');
                    const productSupportTextHeight = $productSupportText.offsetHeight;
                    positionTop = positionTop + productSupportTextHeight;
                }
                smoothScrollTo(0, positionTop, 500);

                setTimeout(() => {
                    this.$productSupportOverview.classList.add('is--invisible');
                    setTimeout(() => {
                        $activeTabItem.click();
                        this.$productSupportOverview.classList.add('is--hidden');
                        $productSupportTabs.classList.remove('is--hidden');
                        this.setTabBarContentHeight();
                    }, 500);
                }, 500);
            } else {
                this.setHistory(historyStateObject);
                this.$productSupportOverview.classList.add('is--hidden');
                setTimeout(() => {
                    $activeTabItem.click();
                    $productSupportTabs.classList.remove('is--hidden');
                    this.setTabBarContentHeight();
                }, 500);
            }
        } else {
            this.hideResults(true);
            const historyStateObject = {
                category: 'product-support',
                pageType: 'overview',
                tabSelected: null
            };

            $productSupportTabs.classList.add('is--hidden');
            this.$productSupportOverview.classList.remove('is--invisible');
            this.$productSupportOverview.classList.remove('is--hidden');
            this.$productOverviewBackButton.classList.add('is--hidden');

            if (withScroll) {
                let positionTop = this.$productSupportOverview.getBoundingClientRect().top + window.scrollY;
                if (this.$header) {
                    positionTop = positionTop - this.$header.offsetHeight;
                }
                setTimeout(() => {
                    smoothScrollTo(0, positionTop, 500);
                }, 500);
                this.setHistory(historyStateObject);
            } else {
                this.setHistory(historyStateObject);
            }
        }
    }

    hideResults (hideProductsResults) {
        this.$productSupportFormResults.classList.remove('is--visible');
        this.$productSupportTopText.classList.remove('is--hidden');
        this.$productSupportResultsPreview.classList.remove('is--hidden');

        if (hideProductsResults === true) {
            this.$productSupportResultsContainer.classList.remove('is--visible');
            this.$productSupportResultsContainer.classList.remove('is--sticky');
        } else {
            this.$productSupportResultsContainer.classList.add('is--sticky');
        }
    }

    setEvents () {
        this.$productSupportOverview.addEventListener('click', (e) => { // handle click on search category teaser
            const $target = e.target.closest('[data-product-support-search]');

            if ($target) {
                const searchCategory = $target.getAttribute('data-product-support-search');

                if (searchCategory) {
                    this.replaceUri(searchCategory);
                    this.checkUrl(true);
                    e.preventDefault();
                }
            }
        });

        if (this.$productOverviewBackButton) {
            this.$productOverviewBackButton.addEventListener('click', () => {
                this.showOverview();
            });
        }

        const $searchItemTabs = document.querySelector('[data-tab-bar="tab-list"]');
        if ($searchItemTabs) {
            $searchItemTabs.addEventListener('click', (e) => {
                const $tabItem = e.target.closest('[data-tab-button]');

                if ($tabItem) {
                    const tabType = $tabItem.getAttribute('data-tab-button');
                    const historyStateObject = {
                        category: 'product-support',
                        pageType: 'overview',
                        tabSelected: tabType
                    };
                    this.replaceUri(tabType);
                    this.setHistory(historyStateObject);

                    if (tabType === 'filter') {
                        if (document.querySelector('.product-support-form__filter-item-third')) {
                            this.$productSupportResultsContainer.classList.add('is--visible');
                        }
                    } else {
                        this.$productSupportResultsContainer.classList.remove('is--visible');
                    }

                    this.setTabBarContentHeight();
                }
            });
        }

        window.addEventListener('popstate', (event) => {
            if (event.state !== null) {
                const state = event.state;
                if (state.category !== null && state.category === 'product-support') {
                    this.checkUrl(true);
                }
            }
        });
    }

    showOverview () {
        const locationUrl = window.location.href;
        const splitUrl = locationUrl.split('#');
        const targetUrl = splitUrl[0];
        const state = { info: 'targetUrl' };
        window.history.replaceState(state, '', targetUrl);
        this.checkUrl(true);
    }

    replaceUri (hash) {
        window.location.hash = hash;
    }

    setHistory (historyStateObject) {
        const title = document.title;
        const uri = document.location.href;
        window.history.replaceState(historyStateObject, title, uri);
    }

    setTabBarContentHeight () {
        const $tabBarContent = document.querySelector('.product-support-tabs__tab-bar-content');
        const $activeContentItem = $tabBarContent.querySelector('.tab-bar__content-item--active');
        const activeContentItemHeight = $activeContentItem.offsetHeight;
        $tabBarContent.style.height = activeContentItemHeight + 'px';
    }
}

export { ProductSupportOverview };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$productSupportOverview = $context.querySelectorAll('.product-support-overview-teaser');

        if ($$productSupportOverview.length > 0) {
            for (let i = 0; i < $$productSupportOverview.length; i++) {
                const $productSupportOverviewItem = new ProductSupportOverview($$productSupportOverview[i]);
                $productSupportOverviewItem.initialize();
            }
        }
    }
});
